<div ngbDropdown placement="bottom" class="kt-header__topbar-item"> <!--kt-header__topbar-item kt-header__topbar-item--langs-->
	<div ngbDropdownToggle class="kt-header__topbar-wrapper"> <!--kt-header__topbar-wrapper-->
		<span class="kt-header__topbar-icon"
			[ngClass]="{ 'kt-header__topbar-icon--brand' : iconType === 'brand' }">
			<!-- <img class="" src="{{language?.flag}}" alt=""/> -->
			<mat-icon class="icon-24">account_circle</mat-icon>
		</span>
	</div>
	<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
		
		<div class="kt-head kt-head--skin-{{skin}} kt-head--fit-x kt-head--fit-b" [ngStyle]="{'background-image': backGroundStyle() }">
			<h3 class="kt-head__title p-2">
				{{'SYSTEM.MY_LEADER.TITLE' | translate}}:
			</h3>
		</div>
		<ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
			<li *ngFor="let leader of myLeaders" class="kt-nav__item">
				<div class="kt-nav__link">
					<mat-icon color="primary" class="pt-1 mr-3">account_circle</mat-icon>
					<span class="kt-nav__link-text">{{leader}}</span>
				</div>
			</li>
		</ul>
	</div>
</div>
